export const sortOptions = [
  { value: 0, label: 'Item Code' },
  { value: 1, label: 'Item Description' },
  { value: 2, label: 'Distributor' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/helper/index.js